/* eslint-disable no-console */
import axios from 'axios';

import {ATTACHED_DOCUMENT_UPLOAD_ERROR} from '../../../components/Forms/Constants/IP/attachedDocumentConstants';
import {API_BASE_URL} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import base64Encode from '../../../shared/base64encoder';
import useUserStore from '../../../store/userStore/userStore';
import showMessage from '../../../utils/showMessage';

export interface UploadAttachedDocumentPayload {
  endpoint: string;
  deletePath?: string;
  file?: File;
}

interface UploadAttachedDocumentResponse {
  status: 'success' | 'error';
  message: string;
  location?: string;
}

export type UploadAttachedDocumentResult =
  | {success: true; location?: string}
  | {success: false};

const uploadAttachedDocumentAPI = async ({
  endpoint,
  deletePath,
  file
}: UploadAttachedDocumentPayload): Promise<UploadAttachedDocumentResult> => {
  const token = useUserStore.getState().userToken;

  const body: {
    deletePath?: string;
    newUpload?: {display_name: string; file: string};
  } = {};

  if (deletePath) {
    body.deletePath = deletePath;
  }

  if (file) {
    body.newUpload = {
      display_name: file.name,
      file: await base64Encode(file)
    };
  }

  try {
    const response = await axios.request<UploadAttachedDocumentResponse>({
      method: CRUDMethods.POST,
      url: `${API_BASE_URL}${endpoint}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: body
    });

    const data = response.data;

    if (data?.status === 'success') {
      if (file) {
        if (data.location) {
          return {success: true, location: data.location};
        }
      } else {
        return {success: true};
      }
    }

    showMessage({
      status: 'error',
      message: ATTACHED_DOCUMENT_UPLOAD_ERROR
    });

    return {success: false};
  } catch (err) {
    console.error('uploadAttachedDocumentAPI error:', err);
    showMessage({
      status: 'error',
      message: ATTACHED_DOCUMENT_UPLOAD_ERROR
    });

    return {success: false};
  }
};

export default uploadAttachedDocumentAPI;
